import React, { Component } from 'react';
import { Container, Row, Col, Jumbotron, HeadingOne } from '../../../legacy/hui/src/styled';
import Hero from '../../images/hero.png';
import HeroMobile from '../../images/hero-mobile.png';

const HeadingOneHero = HeadingOne.extend`
  font-family: 'Roboto';
  font-weight: 200;
  margin-top: 200px;
  color: #fff !important;
  text-align: left;
  font-size: 44px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    margin-top: 90px;
  }
`;

const JumbotronFU = Jumbotron.extend`
  text-align: left;
  font-family: 'Roboto';
  font-weight: 200;
  &:before {
    content: '';
    display: block;
    background: rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  height: 390px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 320px;
  }
`;

export class JumbotronHero extends Component {
  render() {
    return (
      <div>
        <JumbotronFU
          background={{
            lg: Hero,
            md: Hero,
            sm: HeroMobile,
            xs: HeroMobile
          }}
        >
          <Container>
            <Row>
              <Col xs={0} md={12}>
                <HeadingOneHero center>Your install made easy</HeadingOneHero>
              </Col>
              <Col xs={12} md={0}>
                <HeadingOneHero center>
                  Your install
                  <br />
                  made easy
                </HeadingOneHero>
              </Col>
            </Row>
          </Container>
        </JumbotronFU>
      </div>
    );
  }
}
